<template>
  <cv-content id="main-content" style="max-width: 1200px;">
    <cv-tag label="Byteliberi di Paolo Proni" kind="teal" style="width: 100vw; margin-bottom: 1em;"></cv-tag>
    <cv-tabs :container="false" aria-label="navigation tab label">
      <!-- Dati generali sul lavoro svolto -->
      <cv-tab id="tab-1" label="Dati Principali">
        <cv-grid fullWidth> <!-- sm: 4 md: 8 lg: 16 -->
          <cv-row>
            <cv-column :sm="4" :md="8" :lg="8">
              <cv-combo-box label="Seleziona un cliente"
                            title="Cliente" :auto-filter="true"
                            value="Azienda Agricola Mario Rossi s.r.l"
                            :options="options"></cv-combo-box>
            </cv-column>
            <cv-column :sm="4" :md="8" :lg="8">
              <cv-text-input label="Descrizione"
                             value="Estrazione bietole + carico"></cv-text-input>
            </cv-column>
          </cv-row>
          <cv-row>
            <cv-column :sm="4" :md="8" :lg="8">
              <cv-combo-box label="Seleziona una coltura"
                            :auto-filter="true"
                            title="Coltura" value="Barbabietole"
                            :options="options_colture"></cv-combo-box>
            </cv-column>
            <cv-column :sm="4" :md="8" :lg="8">
              <cv-combo-box label="Seleziona un fondo"
                            :auto-filter="true"
                            title="Fondo" value="Russi"
                            :options="options_fondi"></cv-combo-box>
            </cv-column>
          </cv-row>
          <cv-row>
            <cv-column :sm="4" :md="4" :lg="4">
              <cv-combo-box label="Seleziona" title="Unità di misura"
                            value="Ettari (HA)" :auto-filter="true"
                            :options="options_um"></cv-combo-box>
            </cv-column>
            <cv-column :sm="4" :md="4" :lg="4">
              <cv-number-input label="Quantità" title="Quantità" value="1"></cv-number-input>
            </cv-column>
            <cv-column :sm="4" :md="4" :lg="4">
              <cv-text-input label="Tariffa" title="Tariffa" value="€ 200,00"></cv-text-input>
            </cv-column>
            <cv-column :sm="4" :md="4" :lg="4">
              <cv-text-input label="Imponibile" title="Imponibile" value="€ 200,00" readonly></cv-text-input>
            </cv-column>
          </cv-row>
          <cv-row>
            <cv-column :sm="4" :md="4" :lg="4">
              <cv-number-input label="% IVA" title="% IVA" value="10"></cv-number-input>
            </cv-column>
            <cv-column :sm="4" :md="4" :lg="4">
              <cv-number-input label="% Sconto" title="% Sconto" value="0"></cv-number-input>
            </cv-column>
            <cv-column :sm="4" :md="4" :lg="4">
              <cv-text-input label="Sconto" title="Sconto" value="€ 0"></cv-text-input>
            </cv-column>
            <cv-column :sm="4" :md="4" :lg="4">
              <cv-text-input label="Totale da Fatturare" readonly
                             title="Totale da Fatturare" value="€ 220,00"></cv-text-input>
            </cv-column>
          </cv-row>
        </cv-grid>
      </cv-tab>
      <!-- Dati sulle macchine impiegate -->
      <cv-tab id="tab-2" label="Macchine">
        <cv-grid>
          <cv-row>
            <cv-column :sm="2" :md="3" :lg="3">
              <cv-text-input label="Consumo per Unità di Misura"
                             title="Consumo"
                             value="€ 100,00"></cv-text-input>
            </cv-column>
          </cv-row>
          <cv-row>
            <cv-column :sm="4" :md="8" :lg="16">
              <cv-data-table :columns="colonne_macchine"
                             :data="macchine_filtrate"
                             title="Macchine utilizzate in questo lavoro">
              </cv-data-table>
            </cv-column>
          </cv-row>
        </cv-grid>
      </cv-tab>
      <!-- Dati sugli operai impiegati in questo lavoro -->
      <cv-tab id="tab-3" label="Operai">
        <cv-grid>
          <cv-row>
            <cv-column :sm="4" :md="8" :lg="16">
              <cv-data-table :columns="colonne_operai"
                             :data="operai_filtrati"
                             title="Operai impiegati in questo lavoro">
              </cv-data-table>
            </cv-column>
          </cv-row>
        </cv-grid>
      </cv-tab>
      <cv-tab id="tab-4" label="Note">
        <cv-grid>
          <cv-row>
            <cv-column :sm="4" :md="8" :lg="16">
              <cv-text-area
                  label="Annotazioni"
                  value="E' andato tutto bene"></cv-text-area>
            </cv-column>
          </cv-row>
        </cv-grid>
      </cv-tab>
    </cv-tabs>
    <hr/>
    <Bottoniera testo_nuovo="Nuovo L. Tipo"
                testo_salva="Salva L. Tipo"
                :stato="this.$statiPossibili.non_modificato"
                v-on:salva-premuto="$emit('bottone-premuto')"
                v-on:nuovo-premuto="$emit('bottone-premuto')"
                v-on:duplica-premuto="$emit('bottone-premuto')"
                v-on:primo-premuto="$emit('bottone-premuto')"
                v-on:precedente-premuto="$emit('bottone-premuto')"
                v-on:successivo-premuto="$emit('bottone-premuto')"
                v-on:ultimo-premuto="$emit('bottone-premuto')"
                v-on:visualizzazione-premuto="$emit('bottone-premuto')"
                v-on:filtra-premuto="$emit('bottone-premuto')"
                v-on:cancella-premuto="$emit('bottone-premuto')" >

    </Bottoniera>

  </cv-content>
</template>

<script>
import Bottoniera from "@/components/Bottoniera";
import DocumentIco from '@carbon/icons-vue/es/document/16';
import Types from '@carbon/icons-vue/es/types/16';

export default {
  name: "LavoriTipo",
  components: { Bottoniera },
  methods: {

  },
  data: function() {
    return {
      svg_fattura: DocumentIco,
      svg_lavoro_tipo: Types,
      status_Fattura: "Già fatturato",
      colonne_operai: [
        "Nome",
        "Ore"
      ],
      operai_filtrati: [
        [
          "Paolo",
          "8"
        ],
        [
          "Gigi",
          "4"
        ],
      ],
      colonne_macchine: [
        "Descrizione",
        "Targa",
        "Ore"
      ],
      macchine_filtrate: [
        [
          "FENDT",
          "AB 123 CD",
          "100"
        ],
        [
          "FIAT",
          "EF 456 GH",
          "50"
        ],
        [
          "SAME",
          "IL 789 MN",
          "10"
        ],
      ],
      options: [
        {
          value: "1",
          label: "Azienda Agricola Mario Rossi s.r.l",
          name: "Azienda Agricola Mario Rossi s.r.l"
        },
        {
          value: "2",
          label: "Paolo Verdi s.r.l",
          name: "Paolo Verdi s.r.l"
        }
      ],
      options_colture: [
        {
          value: "1",
          label: "Barbabietole",
          name: "Barbabietole"
        },
        {
          value: "2",
          label: "Grano",
          name: "Grano"
        }
      ],
      options_fondi: [
        {
          value: "1",
          label: "Fusignano",
          name: "Fusignano"
        },
        {
          value: "2",
          label: "Russi",
          name: "Russi"
        }
      ],
      options_um: [
        {
          value: "1",
          label: "Ettari (HA)",
          name: "Ettari (HA)"
        },
        {
          value: "2",
          label: "Ore",
          name: "Ore"
        }
      ]
    }
  }
}
</script>

<style lang="scss">
@import '../../styles/carbon';


#main-content {
  background-color: $ui-background;
  color: $text-01;
  //  padding-left: 6rem;

  //  height: 100vh;
  height: 2000px;

  //  width: 100vw;

  //  margin-top: 0px;
  //  padding-top: 1rem;

}

.cv-row {
  padding: 0.5em;
}
</style>